import { Badge, Drawer, Menu, Tabs, Icon, SubMenuSubMenu } from "antd";
import React from "react";
import { connect } from "react-redux";
import { Alert, Loading, SportIcon } from "../";
import { CountryCodes, Enums, AppConfig } from "../../helpers";
import { openMobileMenu, changeFeed } from "../../redux/actions/appActions";
import { getCalenderIcons } from "../../redux/actions/generalActions";
import { getDefaultLiveSportType } from "../../redux/actions/sportEventsActions";

import {
  init,
  loadSportCategories,
  removeDisabledCategoriesTournaments,
  setTounament,
} from "../../redux/actions/categoriesActions";
import {
  loadSportTypes,
  removeDisabledSportTypes,
  setSport,
} from "../../redux/actions/sportTypesActions";
import Images from "./Images";
import Search from "./Search";
import SecondarySearchBar from "./SecondarySearchBar";
import {
  loadSportEventsByDate,
  getWeekMatchDays,
} from "../../redux/actions/sportEventsActions";
import { useMediaQuery } from "react-responsive";
import {
  LazyLoadImage,
  trackWindowScroll,
} from "react-lazy-load-image-component";
import { OnScreenWrapper } from "../../components";
import { ReactSVG } from "react-svg";
import { ManageMemeberFavorite } from "../../redux/actions/membersActions";
import { updateFavoriteCountryForSportEvents } from "../../redux/actions/sportEventsActions";
import { updateFavoriteCountryForSportCategory } from "../../redux/actions/categoriesActions";

const TabPane = Tabs.TabPane;

// const SubMenuTitle = (props) => {
//   const { item } = props;
//   return (
//     <div>
//       <span
//         className={
//           "flag-icon flag-icon-" +
//           getCountryCode(item.categoryDisplayName || "")
//         }
//       />
//       <span className="nav-country">{item.categoryDisplayName}</span>
//     </div>
//   );
// };
const IsMiddleScreenAndMobile = ({ children }) => {
  const isMiddleScreenAndMobile = useMediaQuery({ maxWidth: 1100 });
  return isMiddleScreenAndMobile ? children : null;
};
const IsDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1100 });
  return isDesktop ? children : null;
};

const Title = (props) => {
  const { feedId, sportId, text } = props;

  return (
    <div className="title">
      <SportIcon feedId={feedId} sportId={sportId} />
      <div className="text">{text}</div>
    </div>
  );
};

// const getCountryCode = (countryFlags, item) => {
//   console.log("itemaqaaaaaaaa",item);
//   let result = item && countryFlags.filter((element) => {
//     return element.sportCategoryId == item.sportCategory.sportCategoryId;
//   });
//   if (result && result.length > 0) {
//     return result[0].countryFlagImagesName;
//   }
// };

const MenuItem = (props) => {
  const {
    item,
    onClick,
    title,
    showFlag,
    category,
    countryFlags,
    scrollPosition,
  } = props;
  // countriesFlags
  return (
    <div onClick={onClick} className="nav-div">
      {showFlag && (
        <div
        // className={
        //   "flag-icon flag-icon-" +
        //   getCountryCode(item.sportCategory.categoryDisplayName)
        // }
        >
          <img
            alt="country-flag"
            src={
              AppConfig.countryFlagImagesPath +
              (item.sportCategory.categoryFlagCode
                ? item.sportCategory.categoryFlagCode
                : `eu`) +
              `.webp`
            }
          />
        </div>
      )}
      <div className="nav-text">{title}</div>
      <Badge
        count={item.tournamentActiveEvents}
        className="nav-badge"
        style={{ backgroundColor: "#52c41a" }}
      />
    </div>
  );
};

class MenuTree extends React.Component {
  state = {
    openKeys: [],
    selectedKeys: [],
    searchText: "",
  };

  componentDidUpdate(prevProps) {
    const {
      match,
      connected,
      getWeekMatchDays,
      getDefaultLiveSportType,
    } = this.props;
    const request = {
      Data: {
        Feed: { FeedId: Number(match.params.feed) },
        Sport: { SportId: Number(match.params.sport) },
      },
    };

    if (
      (!prevProps.connected && connected)
    ) {
      getDefaultLiveSportType();
      getWeekMatchDays(request);
    }
    if (
      prevProps.appMatch &&
      prevProps.appMatch.url !== this.props.appMatch.url
    ) {
      this.handleOpenTree();
    }
    if (
      (prevProps.sportTypes.length > 0 && this.props.sportTypes.length === 0) ||
      (!prevProps.connected && this.props.connected)
    ) {
      let request = {
        Data: {
          Feed: {
            FeedId: this.props.appMatch.url.includes("account")
              ? 6
              : Number(this.props.match.params.feed),
          },
        },
      };
      this.props.loadSportTypes(request);
    }
  }

  componentDidMount() {
    const {
      loadSportTypes,
      match,
      connected,
      getCalenderIcons,
      getWeekMatchDays,
      getDefaultLiveSportType,
      feedId
    } = this.props;
    getCalenderIcons();

    
    if (connected) {
      const weekDaysRequest = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
        },
      };
      getWeekMatchDays(weekDaysRequest);
      let request = {
        Data: {
          Feed: {
            FeedId: match.url.includes("account")
              ? 6
              : Number(match.params.feed),
          },
        },
      };
      loadSportTypes(request);
      getDefaultLiveSportType();
    }
    this.handleOpenTree();
  }

  handleOpenTree() {
    const { tournamentData, appMatch, match } = this.props;

    let tempMatch = appMatch ? appMatch : match;
    let openKeys = [];
    let selectedKeys = [];
    let sport = tempMatch.params.sport;
    let feed = tempMatch.params.feed;
    let section = tempMatch.params.section;
    let country = tempMatch.params.country;
    let tournament = tempMatch.params.tournament;
    let day = tempMatch.params.day;
    openKeys.push(`${sport}${feed}`);
    openKeys.push(section);
    openKeys.push(`C${country}`);
    day !== undefined && selectedKeys.push(`today`);
    tournament && selectedKeys.push(`${country}${tournament}`);

    tournamentData &&
      openKeys.push(
        `${tournamentData.sportCategory.sportCategoryId}${
          tournamentData.sportCategory.sportCategoryDisplayName
        }`
      );

    this.setState({
      openKeys,
      selectedKeys,
    });
  }

  navigate = (
    route,
    feedId = Enums.Feed.Static,
    feedName = Enums.FeedNames.Static
  ) => {
    const { changeFeed, history } = this.props;
    if (history.location.pathname != route) {
      history.push(`${route}`);
      changeFeed(feedId.toString(), feedName);
    }
  };

  onSearchChange = (e) => {
    this.setState({
      searchText: e.target.value,
    });
  };

  handleFilter = (category, searchText) => {
    const itemName = category.categoryDisplayName.toLowerCase();
    const sT = searchText.toLowerCase();
    if (sT.length === 0) return true;
    if (itemName.indexOf(sT) > -1) {
      return true;
    } else {
      return false;
    }
  };

  onMenuClick = (section, item) => {
    const { openMobileMenu, history, setTounament, match } = this.props;
    openMobileMenu(false);
    // to revert to old code, change tournamnetUid to tournamentId
    if (match.url.includes("account")) {
      history.push(
        `/sport/${item.feed.feedId}/${item.sport.sportId}/${
          item.sport.sportDisplayName
        }/events/${section}/${item.sportCategory.sportCategoryId}/${
          item.sportCategory.categoryDisplayName
        }/${item.tournamentUId}/${item.tournamentDisplayName}/${
          item.sportCategory.categoryFlagCode
        }`
      );
      window.scrollTo(0, 0);
    } else {
      const countryFlag = item.sportCategory.categoryFlagCode
        ? item.sportCategory.categoryFlagCode
        : "eu";
      history.push(
        `${match.url}/events/${section}/${item.sportCategory.sportCategoryId}/${
          item.sportCategory.categoryDisplayName
        }/${item.tournamentUId}/${item.tournamentDisplayName}/${countryFlag}`
      );
      window.scrollTo(0, 0);
    }

    setTounament(item);
    removeDisabledCategoriesTournaments();
  };

  onTodayClick = (day = "0", isLastMin = false) => {
    const { openMobileMenu, history, match } = this.props;
    openMobileMenu(false);

    history.push(`${match.url}/today/${day}`);
    removeDisabledCategoriesTournaments();
  };

  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find(
      (key) => this.state.openKeys.indexOf(key) === -1
    ); //get last open key
    if (
      this.props.sportTypes.findIndex(
        (item) => `${item.sport.sportId}${item.feed.feedId}` == latestOpenKey
      ) === -1
    ) {
      // check if not exist in sportTypes keys
      this.setState({ openKeys }); //kep openKeys
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [], // init openKeys with the newsport
      });
    }
  };

  onTitleClick(input, sport) {
    const { sportData } = this.props;
    if (sport.sport.sportId != sportData.sport.sportId) {
      this.onSportTypeClick(sport);
    }
    this.setState({ selectedSport: sport.sport.sportId });
  }

  onSportTypeClick = (item) => {
    const {
      history,
      setSport,
      feedName,
      loadSportCategories,
      removeDisabledSportTypes,
      feedId,
      match,
    } = this.props;
    // if (
    //   (item.feed.feedId == 6 && item.sport.sportId == 1) ||
    //   item.feed.feedId == 5
    // ) {
    history.push(
      `/${feedName}/${feedId}/${item.sport.sportId}/${
        item.sport.sportDisplayName
      }`
    );
    //}
    //Go to today
    // else {
    //   history.push(
    //     `/${feedName}/${feedId}/${item.sport.sportId}/${
    //       item.sport.sportDisplayName
    //     }/today/0`
    //   );
    // }

    setSport(item);
    removeDisabledSportTypes();

    const request = {
      Data: {
        Feed: { FeedId: Number(item.feed.feedId) },
        Sport: { SportId: Number(item.sport.sportId) },
      },
    };
    loadSportCategories(request);
  };

  onOpenStats = () => {
    window.open(
      //"https://s5.sir.sportradar.com/sportbookcloud/en",
      `${AppConfig.StatisticsAddress.Domain}?path=${
        AppConfig.StatisticsAddress.Menu
      }`,
      "_blank",
      "toolbar=no,scrollbars=no,resizable=no,top=100,left=100,width=1000,height=1000"
    );
  };

  getTabName(today, i) {
    let dayNumber = today + i + 1;
    dayNumber =
      dayNumber >= Enums.Days.length
        ? dayNumber - Enums.Days.length
        : dayNumber;
    return Enums.daysFormatted[dayNumber];
  }
  // onTodayClick = (day = "0", isLastMin = false) => {
  //   const { history, loadSportEventsByDate, match } = this.props;
  //   history.push(`${day}`);
  //   const request = {
  //     Data: {
  //       Feed: { FeedId: Number(match.params.feed) },
  //       Sport: { SportId: Number(match.params.sport) },
  //       Day: Number(day),
  //       IsLastMin: isLastMin,
  //     },
  //   };
  //   loadSportEventsByDate(request);
  // };

  applyByDayFilter(key) {
    const isLastMin = key == "-1" ? true : false;
    this.onTodayClick(key, isLastMin);
    this.setState({ collapseAll: false, leaguesIds: undefined });
  }
  // getCountryImage(category) {
  //   // sportCategoryId
  //   const { countryFlags } = this.props;
  //   let result = countryFlags.filter((item) => {
  //     return item.sportCategoryId == category.sportCategoryId;
  //   });
  //   if (result && result.length > 0) {
  //     return result[0].countryFlagImagesName;
  //   }
  // }


  getCalendarImagePath(tabName) {
    const { calenderImages } = this.props;
    let calendarIconName = "";
    calenderImages &&
      calenderImages.calendarIcons &&
      calenderImages.calendarIcons.map((item) => {
        if (item.iconName.includes(tabName)) {
          calendarIconName = `${item.calendarIconName}?id=${item.imageVersion}`;
        }
      });
    return calendarIconName;
  }
  addToFavorate = (e, sportCategoryUId  ) => {
    e.stopPropagation();
    const { ManageMemeberFavorite, match, updateFavoriteCountryForSportEvents , updateFavoriteCountryForSportCategory} = this.props;
    const favItemKey = `1-${sportCategoryUId}-${match.params.sport}`;
    const memberFavorites =
      localStorage.getItem("memberFavorites") &&
      JSON.parse(localStorage.getItem("memberFavorites"));
    // if memberFavorites not exist then stop the function, else complete
    if (!memberFavorites) return;
    //
    const existingIndex = memberFavorites.findIndex(
      (item) => item.key === favItemKey
    );
    if (existingIndex > -1) {
      let element = memberFavorites.filter((item) => item.key == favItemKey);
      let data = {
        favoriteId: element[0].favoriteId,
        favoriteType: {
          favoriteTypeId: 1,
        },
        feedId: Number(match.params.feed),
        sportId: Number(match.params.sport),
        elementId: Number(sportCategoryUId),
      };
      ManageMemeberFavorite(data);
    } else {
      let data = {
        favoriteType: {
          favoriteTypeId: 1,
        },
        feedId: Number(match.params.feed),
        sportId: Number(match.params.sport),
        elementId: Number(sportCategoryUId),
      };
      ManageMemeberFavorite(data);
    }
      updateFavoriteCountryForSportEvents(sportCategoryUId)
      updateFavoriteCountryForSportCategory(sportCategoryUId)
  };

  renderCategories = (
    categories,
    topCategories,
    sportTypes,
    categoriesError
  ) => {
    const byDays = ["Last minute bets", "TODAY"];
    const today = new Date().getDay();
    const { openKeys, selectedKeys } = this.state;
    const {
      loadingSportCategories,
      sportData,
      feedName,
      match,
      calenderImages,
      calenderImagesError,
      loadingCalender,
      fixtureImage,
      statisticImage,
      loadingWeekMatchDays,
      weekMatchDaysError,
      weekMatchDays,
      landingImage,
      promotionImage
    } = this.props;
    const doesWeekDaysExist =
      weekMatchDays &&
      Object.keys(weekMatchDays) &&
      Object.keys(weekMatchDays).length > 0;
    const todayMatches =
      doesWeekDaysExist &&
      Object.keys(weekMatchDays).filter((item) => item == "1");
    const defaultSport =
      todayMatches && todayMatches.length > 0
        ? Number(todayMatches[0] - 1)
        : doesWeekDaysExist ? Number(Object.keys(weekMatchDays)[0]) - 1 : undefined;

    const day = Number(
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ]
    );
    //
    let sportId;
    if (sportData) sportId = sportData.sport.sportId;
    return (
      <div id="side-menu" className="menu-tree-side">
        <Menu
          className="menu"
          mode="inline"
          openKeys={openKeys}
          selectedKeys={selectedKeys}
          onOpenChange={this.onOpenChange}
        >
          {/* <div className="item">
          <div className="title">{feedName}</div>
        </div> */}

          {sportTypes
            .filter((da) => da.sport.sportId === sportId)
            .map((data) => {
              return (
                <div key={data.sport.sportId}>
                  {loadingSportCategories &&
                    sportData.sport.sportId === data.sport.sportId && (
                      <div className="today">
                        <Loading />
                      </div>
                    )}

                  <h2 className="menu-banner">Top Leagues</h2>
                  {topCategories && (
                    //&& topCategories[0].tournamentId > 0
                    <div className="sub-menu" title="Top Leagues" key="top">
                      {topCategories &&
                        topCategories.map((category) => {
                          return (
                            <div
                              className="item"
                              title={`${category.tournamentDisplayName}`}
                              key={`${category.sportCategory.sportCategoryId}${
                                category.tournamentId
                              }`}
                              style={
                                selectedKeys[0] ==
                                `${category.sportCategory.sportCategoryId}${
                                  category.tournamentId
                                }`
                                  ? {
                                      borderRight: "4px solid red",
                                      backgroundColor: "var(--light-black)",
                                      borderRadius: "5px",
                                    }
                                  : {
                                      borderRight: "0px",
                                      backgroundColor: "transparent",
                                    }
                              }
                            >
                              <OnScreenWrapper
                                styleFunction={(bool) => ({
                                  width: "100%",
                                  height: bool ? "fit-content" : 40,
                                })}
                              >
                                <MenuItem
                                  className="item"
                                  showFlag
                                  countryFlags={this.props.countryFlags}
                                  item={category}
                                  title={`${category.tournamentDisplayName}`}
                                  onClick={() =>
                                    this.onMenuClick("top", category)
                                  }
                                />
                              </OnScreenWrapper>
                            </div>
                          );
                        })}
                    </div>
                  )}

                  {/* <div
                    className="menu-banner by-day-container"
                    onClick={() => this.applyByDayFilter("0")}
                  >
                    By Day
                    <img src={Images.DownArrow} alt="down-arrow" />
                  </div> */}
                  {this.props.feedId != Enums.Feed.Live && (
                    <h2 className="menu-banner">By Day</h2>
                  )}
                  {this.props.feedId != Enums.Feed.Live &&
                    (loadingWeekMatchDays ? (
                      <Loading />
                    ) : weekMatchDaysError ? (
                      <Alert type="error" message={weekMatchDaysError} />
                    ) : weekMatchDays ? (
                      <div className="sub-menu">
                        {Object.entries(weekMatchDays) &&
                          Object.entries(weekMatchDays).length > 0 &&
                          Object.entries(weekMatchDays).map((item) => {
                            return item[0] == "0" ? (
                              <div
                                className="byday-menu-title"
                                key={`${item[0]}-${item[1]}`}
                                style={
                                  selectedKeys[0] == "today" &&
                                  (day == -1 ||
                                    (day == 0 && defaultSport == -1))
                                    ? {
                                        backgroundColor: "var(--light-black)",

                                        borderRight: "4px solid red",
                                      }
                                    : {
                                        borderRight: "0px",
                                        backgroundColor: "transparent",
                                      }
                                }
                                onClick={() =>
                                  selectedKeys[0] == "today" &&
                                  (day == -1 ||
                                    (day == 0 && defaultSport == -1))
                                    ? ""
                                    : this.applyByDayFilter("-1")
                                }
                              >
                                <div>
                                  <img
                                    src={
                                      this.getCalendarImagePath(`LastMinBet`)
                                    }
                                    alt="calender-icons"
                                  />
                                  Last minute
                                </div>
                                <span>{item[1]}</span>
                              </div>
                            ) : item[0] == "1" ? (
                              <div
                                className="byday-menu-title"
                                key={`${item[0]}-${item[1]}`}
                                style={
                                  selectedKeys[0] == "today" &&
                                  (day == -2 || (day == 0 && defaultSport == 0))
                                    ? {
                                        backgroundColor: "var(--light-black)",

                                        borderRight: "4px solid red",
                                      }
                                    : {
                                        borderRight: "0px",
                                        backgroundColor: "transparent",
                                      }
                                }
                                onClick={() =>
                                  selectedKeys[0] == "today" &&
                                  (day == -2 || (day == 0 && defaultSport == 0))
                                    ? ""
                                    : this.applyByDayFilter("-2")
                                }
                              >
                                <div>
                                  <img
                                    src={
                                      this.getCalendarImagePath(`Today`)
                                    }
                                    alt="calender-icons"
                                  />
                                  Today
                                </div>
                                <span>{item[1]}</span>
                              </div>
                            ) : (
                              <div
                                className="byday-menu-title"
                                key={`${item[0]}-${item[1]}`}
                                style={
                                  selectedKeys[0] == "today" &&
                                  (day == item[0] - 1 ||
                                    (day == 0 && defaultSport == item[0] - 1))
                                    ? {
                                        backgroundColor: "var(--light-black)",
                                        borderRight: "4px solid red",
                                      }
                                    : {
                                        backgroundColor: "transparent",

                                        borderRight: "0px",
                                      }
                                }
                                onClick={() =>
                                  selectedKeys[0] == "today" &&
                                  (day == item[0] - 1 ||
                                    (day == 0 && defaultSport == item[0] - 1))
                                    ? ""
                                    : this.applyByDayFilter(`${item[0] - 1}`)
                                }
                              >
                                <div>
                                  <img
                                    src={
                                      this.getCalendarImagePath(
                                        `${this.getTabName(
                                          today,
                                          Number(item[0]) - 2
                                        )}`
                                      )
                                      
                                    }
                                    alt="calender-icons"
                                  />
                                  
                                  {(Number(item[0]) -1 == 1) ? `Tomorrow` :this.getTabName(today, Number(item[0]) - 2)}
                                </div>
                                <span>{item[1]}</span>
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      ""
                    ))}

                  {/* all counties */}
                  <h2 className="menu-banner">All Countries</h2>
                  {
                    <div
                      id="sub-menu-items"
                      className="sub-menu"
                      key="countries"
                      title="Countries"
                    >
                      <SecondarySearchBar onChange={this.onSearchChange} />
                      {categories &&
                        categories
                          .filter((item) =>
                            this.handleFilter(item, this.state.searchText)
                          )

                          .map((category) => {
                            const children = category.sportTournaments;
                            const hasChildren = children && children.length > 0;
                            if (categoriesError) {
                              return <div>{categoriesError}</div>;
                            }
                            if (hasChildren) {
                              return (
                                <div
                                  key={`${category.sportCategoryId}`}
                                  className="sub-menu-divs"
                                >
                                  <Menu mode="inline">
                                    <Menu.SubMenu
                                      className="submenu"
                                      title={
                                        <OnScreenWrapper
                                          styleFunction={(bool) => ({
                                            width: "100%",
                                            height: bool ? "fit-content" : 40,
                                          })}
                                        >
                                          <div>
                                          {this.props.signedIn && (
                                              <div className="teams-star-container" style={{display:"inline-flex", marginLeft:"0px"}}>
                                                    <ReactSVG
                                                      className={`${
                                                          category.isFavorite
                                                          ? `favorite-icon-selected`
                                                          : ``
                                                      }`}
                                                      src={Images.LuckyNumberStar}
                                                      onClick={(e) =>
                                                        this.addToFavorate(
                                                          e,
                                                          category.sportCategoryUId,
                                                        )
                                                      }
                                                    />
                                                </div>
                                          )}
                                            <img
                                              src={
                                                AppConfig.countryFlagImagesPath +
                                                (category.categoryFlagCode
                                                  ? category.categoryFlagCode
                                                  : `eu`) +
                                                `.webp`
                                              }
                                              style={{marginBottom:"4px"}}
                                              alt="country-flag"
                                            />
                                            {category.categoryDisplayName}
                                          </div>
                                        </OnScreenWrapper>
                                      }
                                    >
                                      {children.map((child) => {
                                        return (
                                          <div
                                            className="item"
                                            title={child.tournamentDisplayName}
                                            key={`${
                                              child.sportCategory
                                                .sportCategoryId
                                            }${child.tournamentId}`}
                                            style={
                                              selectedKeys[0] ==
                                              `${
                                                child.sportCategory
                                                  .sportCategoryId
                                              }${child.tournamentId}`
                                                ? {
                                                    borderRight:
                                                      "4px solid red",
                                                    backgroundColor:
                                                      "var(--light-black)",
                                                    borderRadius: "5px",
                                                  }
                                                : {
                                                    borderRight: "0px",
                                                    backgroundColor:
                                                      "transparent",
                                                  }
                                            }
                                          >
                                            <OnScreenWrapper
                                              styleFunction={(bool) => ({
                                                width: "100%",
                                                height: bool
                                                  ? "fit-content"
                                                  : 40,
                                              })}
                                            >
                                              <MenuItem
                                                className="item"
                                                showFlag
                                                category={category}
                                                countryFlags={
                                                  this.props.countryFlags
                                                }
                                                item={child}
                                                title={
                                                  child.tournamentDisplayName
                                                }
                                                onClick={() =>
                                                  this.onMenuClick(
                                                    "countries",
                                                    child
                                                  )
                                                }
                                              />
                                            </OnScreenWrapper>
                                          </div>
                                        );
                                      })}
                                    </Menu.SubMenu>
                                  </Menu>
                                </div>
                                // <div
                                //   className="sub-menu"
                                //   key={`C${category.sportCategoryId}`}
                                //   title={<SubMenuTitle item={category} />}
                                // >
                                //   {children.map((child) => {
                                //     return (
                                //       <div
                                //         className="item"
                                //         title={child.tournamentDisplayName}
                                //         key={`${child.sportCategory.sportCategoryId}${child.tournamentId}`}
                                //       >
                                //         <MenuItem
                                //           className="item"
                                //           item={child}
                                //           title={child.tournamentDisplayName}
                                //           onClick={() =>
                                //             this.onMenuClick("countries", child)
                                //           }
                                //         />
                                //       </div>
                                //     );
                                //   })}
                                // </div>
                              );
                            }
                          })}
                    </div>
                  }
                </div>
              );
            })}
          <OnScreenWrapper>
            <h2 className="menu-banner">Bets Services</h2>
            <div id="menu-tree-bet-services" className="sub-menu">
              <div
                onClick={() => this.onOpenStats()}
                className="menu-item bet-services-container"
              >
                <div style={{ display: "flex" }}>
                  {" "}
                  <img
                    src={statisticImage}
                    alt="statistics"
                    style={{ marginLeft: "5px", width: "25px" , height:"20px" }}
                  />{" "}
                </div>{" "}
                <span style={{ marginLeft: "6px" }}> Statistics</span>
              </div>
              <div
                onClick={() => this.navigate("/fixture", Enums.Feed.Fixture)}
                className="menu-item bet-services-container"
              >
                <div style={{ display: "flex" }}>
                  <img
                    style={{ marginLeft: "5px" , width: "25px" , height:"20px"}}
                    src={fixtureImage}
                    alt="fixtures"
                  />
                </div>{" "}
                <span style={{ marginLeft: "6px" }}> Fixture & Results</span>
              </div>
              <div
                onClick={() => this.navigate("/promos", Enums.Feed.Promos)}
                className="menu-item bet-services-container"
              >
                <div style={{ display: "flex" }}>
                  <img
                    style={{ marginLeft: "5px" , width: "25px" , height:"20px"}}
                    src={promotionImage}
                    alt="fixtures"
                  />
                </div>{" "}
                <span style={{ marginLeft: "6px" }}> Promotions</span>
              </div>
              <div
                style={{ paddingBottom: "20px", paddingTop: "20px" }}
                onClick={() => this.navigate("/", Enums.Feed.Landing)}
                className="menu-item"
              >
                <div style={{ display: "flex" }}>
                  <img
                    style={{ marginLeft: "5px" , width: "25px" , height:"20px"}}
                    src={landingImage}
                    alt="fixtures"
                  />
                </div>{" "}
                <span style={{ marginLeft: "6px" }}> Landing</span>
              </div>
            </div>
          </OnScreenWrapper>
        </Menu>
      </div>
    );
  };

  render() {
    const {
      mobileMenuOpen,
      openMobileMenu,
      sportCategories,
      sportTopLeagues,
      sportTypes,
      sportTypesError,
      categoriesError,
      loadingSportTypes,
    } = this.props;
    if (loadingSportTypes) {
      return <Loading />;
    }
    if (sportTypesError) {
      return <div>{sportTypesError}</div>;
    }

    return (
      <div>
        <IsMiddleScreenAndMobile>
          <Drawer
            width={220}
            className="mobile"
            placement="left"
            closable={false}
            onClose={() => openMobileMenu(false)}
            visible={mobileMenuOpen}
          >
            {mobileMenuOpen &&
              sportTypes &&
              sportTypes.length > 0 &&
              this.renderCategories(
                sportCategories,
                sportTopLeagues,
                sportTypes,
                categoriesError
              )}
          </Drawer>
        </IsMiddleScreenAndMobile>
        <IsDesktop>
          {sportTypes &&
            sportTypes.length > 0 &&
            this.renderCategories(
              sportCategories,
              sportTopLeagues,
              sportTypes,
              categoriesError
            )}
        </IsDesktop>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sportCategories: state.categories.sportCategories,
    sportTopLeagues: state.categories.sportTopLeagues,
    tournamentData: state.categories.tournamentData,
    loadingSportCategories: state.categories.loadingSportCategories,
    categoriesError: state.categories.error,
    sportTypesError: state.sportTypes.error,
    loadingSportTypes: state.sportTypes.loadingSportTypes,
    sportData: state.sportTypes.sportData,
    sportTypes: state.sportTypes.sportTypes,
    appMatch: state.app.match,
    mobileMenuOpen: state.app.mobileMenuOpen,
    calenderImages: state.general.calenderImages,
    calenderImagesError: state.general.calenderImagesError,
    loadingCalender: state.general.loadingCalender,
    fixtureImage: state.general.configuration.fixtureImage,
    promotionImage: state.general.configuration.promotionImage,
    landingImage: state.general.configuration.landingImage,
    statisticImage: state.general.configuration.statisticImage,
    countryFlags: state.general.countryFlags,
    loadingWeekMatchDays: state.sportEvents.loadingWeekMatchDays,
    weekMatchDaysError: state.sportEvents.weekMatchDaysError,
    weekMatchDays: state.sportEvents.weekMatchDays,
    signedIn: state.auth.signedIn,
    feedId: state.app.feedId,
    connected: state.app.feedId == Enums.Feed.Static ?
			state.signalr.staticConnected :
			state.app.feedId == Enums.Feed.Live ?
				state.signalr.liveConnected :
				state.signalr.connected,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    changeFeed: (feedId, feedName) => dispatch(changeFeed(feedId, feedName)),
    openMobileMenu: (open) => dispatch(openMobileMenu(open)),
    loadSportCategories: (request) => {
      dispatch(loadSportCategories(request));
    },
    setTounament: (item) => {
      dispatch(setTounament(item));
    },
    init: () => {
      dispatch(init());
    },
    getDefaultLiveSportType: () => {
      dispatch(getDefaultLiveSportType());
    },
    setSport: (item) => {
      dispatch(setSport(item));
    },
    loadSportTypes: (request) => {
      dispatch(loadSportTypes(request));
    },
    removeDisabledSportTypes: () => {
      dispatch(removeDisabledSportTypes());
    },
    removeDisabledCategoriesTournaments: () => {
      dispatch(removeDisabledCategoriesTournaments());
    },
    loadSportEventsByDate: (request) => {
      dispatch(loadSportEventsByDate(request));
    },
    getCalenderIcons: () => {
      dispatch(getCalenderIcons());
    },
    getWeekMatchDays: (request) => {
      dispatch(getWeekMatchDays(request));
    },
    ManageMemeberFavorite: (data) => {
      dispatch(ManageMemeberFavorite(data));
    },
    updateFavoriteCountryForSportEvents: (sportCategoryUId) => {
      dispatch(updateFavoriteCountryForSportEvents(sportCategoryUId));
    },
    updateFavoriteCountryForSportCategory: (sportCategoryUId) => {
      dispatch(updateFavoriteCountryForSportCategory(sportCategoryUId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(trackWindowScroll(MenuTree));
